import * as actions from './contentActions';

const contentReducers = {
  [actions.CONTENT_STORED]: (
    state,
    { payload: { type, language, content } }
  ) => {
    state[`${type}_${language}`] = content;
    return state;
  },
};

export default {
  name: 'content',
  reducers: contentReducers,
};
